// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"20845":"8123982dc5440142","43907":"9afe624927c5e8d8","90313":"589d8a59a4be3154"}[chunkId] + ".css";
};